(function($){
    // JS
    window.Search = {

        // Show or hide the search form
        //======================================================================
        toggleSearchForm: function()
        {
            $(document).on('click', '.js-search-toggle', function(e){
                e.preventDefault();

                $('.search-form-wrap').fadeToggle();
                $('#search').focus();

            });
        }
    }

    // Run
    $(function(){
        Search.toggleSearchForm();
    });


}(jQuery));